import { get, map } from 'lodash/fp';
import React from 'react';

import FAQStructuredContentBlock from '../../../../components/faq-structured-content-block';
import ProductReviewInlineWidgetScript from '../product-review-inline-widget-script';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';
import type { InsuranceTypeContent } from '../../types';

const mapWithIndex = uncapFpIterator(map);

type PageSectionsProps = {
  components: {
    [key: string]: React.ElementType | null;
  };
  content: InsuranceTypeContent;
  insuranceType: string;
};

const PageSections = ({ components, content, insuranceType }: PageSectionsProps) => {
  const sections = get('sections', content);
  return (
    <>
      <ProductReviewInlineWidgetScript insuranceType={insuranceType} />
      {mapWithIndex((section: { type: string }, index: React.Key) => {
        const Component = components[section.type] as typeof React.Component;
        if (!Component) return null;
        return <Component key={index} {...section} insuranceType={insuranceType} />;
      }, sections)}
      <FAQStructuredContentBlock faqs={content?.faqQuestions} />
    </>
  );
};

export default PageSections;
